export default "__VITE_ASSET__CKt$WBck__ 584w";